<template>
  <Content class="col-span-full" :title="$route.name" type="list">
    <tableSearch
      @search="search = $event"
      :placeholder="
        $t('SEARCH_FOR', {
          type: $t('FA_TITLE'),
        })
      "
    />

    <el-table
      :empty-text="$t('NO_DATA')"
      :data="
        tableData.filter((data) => !search || data.fa_title.includes(search))
      "
      v-loading="loading"
      :stripe="true"
      style="width: 100%"
    >
      <el-table-column
        sortable
        type="index"
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('INDEX')"
        width="60"
      >
        <template slot-scope="scope">
          <div :data-title="$t('INDEX')">
            {{ scope.$index + 1 }}
          </div>
        </template>
      </el-table-column>

      <el-table-column
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('FA_TITLE')"
        width="160"
      >
        <template slot-scope="scope">
          <div :data-title="$t('FA_TITLE')">
            {{ scope.row.fa_title }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('EN_TITLE')"
        width="160"
      >
        <template slot-scope="scope">
          <div :data-title="$t('EN_TITLE')">
            {{ scope.row.en_title }}
          </div>
        </template>
      </el-table-column>

      <!-- <el-table-column
        :align="$i18n.locale == 'fa' ? 'right' : 'left'"
        :label="$t('DATE')"
        width="120"
      >
        <template slot-scope="scope">
          <div :data-title="$t('DATE')">
            {{ scope.row.date | getPersianDate }}
          </div>
        </template>
      </el-table-column> -->
    </el-table>
  </Content>
</template>

<script>
import { getCarsTag } from '@/api/cars'
import tableSearch from '@/components/elements/tableSearch'

export default {
  data() {
    return {
      tableData: [],
      loading: true,
      search: '',
    }
  },

  methods: {},
  mounted() {
    getCarsTag.api().then((res) => {
      if (res) {
        this.tableData = res
      }
      this.loading = false
    })
  },
  components: {
    // tableFeatures,
    tableSearch,
  },
}
</script>
